<template>
  <div>
    <v-toolbar class="sub-toolbar" flat>
        <!-- Comentamos el filtro de momento para cuando haya mas opciones de filtrado  -->
          <!-- <a class="unishop-filters" @click="showFiltro()" v-if="!this.$store.getters.isFiltroLooksOpen"></a>
          <i class="unishop-filter-on icon-filter3" v-if="((this.$store.state.userInfo.hasLookSearched > 0 )  && (this.$store.state.userInfo.lookLocalizadorSearched === ''))"></i> -->
          <div  class="no-flex" v-if="!$store.getters.isTicketsOpen"><!--v-if="!$store.getters.isTicketsOpen && !localizadorOpen"
            <img @click="modalScan = true" src='@/assets/images/barcodescan.png'>-->
            <v-btn flat icon class="my-0 primary-color" @click="dialog = true" > <v-icon>flip</v-icon></v-btn><!--@click="modalScan = true"-->
          </div>
          <a class="unishop-filters" @click="closeFiltro()" v-if="this.$store.getters.isFiltroLooksOpen" style="background-position: 0 -32px;"></a>
          <div class="d-flex align-center mr-auto back ml-3">
            <v-text-field
              v-model="localizador"
              label="Buscar look"
              class="pt-1 ml-2"
              single-line
              @keyup.enter="search()"
            ></v-text-field>
              <!--<input
                v-model="localizador"
                placeholder="Busqueda"
              >-->
          <v-icon v-if="(this.$store.state.userInfo.hasLookSearched > 0)" @click="reset();localizador=''" class="primary-color ">close</v-icon>
              <v-badge
                color="orange"
                dark
                small
                mr-2
                v-if="(this.$store.state.userInfo.hasLookSearched > 0)"
                >
                <template v-slot:badge>
                  <v-icon class="white--text">priority_high</v-icon>
                </template>
              </v-badge>
          <v-btn icon flat @click="search()" :class="[' pointer my-0' , this.$store.getters.isFiltroLooksOpen || localizador=='' ? 'deshab' : '']">
              <v-icon class="primary-color"> search</v-icon>
            </v-btn>
            <!-- <i class="unishop-filter-on buscar-on icon-filter3" v-if="(this.$store.state.userInfo.hasLookSearched > 0 && (this.$store.state.userInfo.lookLocalizadorSearched !== ''))"></i> -->
            <!--<i class="unishop-filter-on buscar-on icon-filter3" v-if="(this.$store.state.userInfo.hasLookSearched > 0)"></i>-->
        </div>
    
        <v-btn v-if="permitido('MOBILESTORE.LOOKS.CRUD')" flat class="primary-color" :to="'/lookcreator'" >
          <v-icon class="mr-2">content_cut</v-icon>
          Crear nuevo look
        </v-btn>
    </v-toolbar>

    <v-dialog
      v-model="dialog"
      max-width="400"
      class="no-flex"
    > 
      <div class="scan-dialog">
        <v-toolbar flat class="d-flex justify-space-between ">
            <v-toolbar-title class="primary-color"><v-icon class="mr-2 primary-color">flip</v-icon>Escanear localizador</v-toolbar-title>
            <v-btn 
              icon
              flat
              class="primary-color"
              @click="dialog = false">
            <!--<img class='btn-footer-izq pointer' src='@/assets/images/Btn-ESC.gif' >-->
            <!--{{ $t('lang.comun.salir') }}-->
            <v-icon>close</v-icon>
            </v-btn>
        </v-toolbar>
        <code-scanner v-if="dialog" @search-by-ean-code="searchByEanCode" />
        <!--v-on:cerrar="modalScan=false" -->
      </div>
    </v-dialog>
  </div>
</template>
<script>
  import CodeScanner from "../../../../components/CodeScanner.vue";

  export default {
    name: 'Menu',
    components: { CodeScanner, },
    data () {
      return {
        localizador: '',
        dialog: false
      }
    },
    mounted() {
      this.localizador =this.$store.state.userInfo.lookLocalizadorSearched
    },
    methods: {
      showFiltro () {
        this.$store.commit('showFiltroLooks', true);   
      },
      closeFiltro () {
        this.$store.commit('showFiltroLooks', false);
      },
      search () {
        // CAMBIO TEMPORAL, al no haber filtro de momento usamos el localizador tambien para buscar por titulo y desc
        // if (this.localizador.length > 0) {
        //   this.$store.commit('setHasUserSearchedLook', this.$store.state.userInfo.hasLookSearched + 1);
        //   this.$store.commit('setLookLocalizadorSearched', this.localizador);
        //   this.$store.commit('cambioPag', 1)
        // } 
        if (this.localizador.length > 0) {
          if (isNaN(this.localizador)) { 
            this.$store.commit('setLookNombreSearched', this.localizador);
          } else {
            this.$store.commit('setLookLocalizadorSearched', this.localizador);
          }
          this.$store.commit('setHasUserSearchedLook', this.$store.state.userInfo.hasLookSearched + 1);
          this.$store.commit('cambioPag', 1)
        } 
      },
      searchByEanCode (ean) {
        this.localizador = ean
        this.search()
      },
      reset () {
        this.localizador=''
        this.$store.commit('cambioPag', 1)
        this.$store.commit('setHasUserSearchedLook', 0);
        this.$store.commit('setLookLocalizadorSearched', '');
        // CAMBIO TEMPORAL
        this.$store.commit('setLookNombreSearched', this.nombre);
      }
    }
  };
</script>
